<bit-breadcrumbs>
  @if (vaultCrumb(); as crumb) {
    <bit-breadcrumb [route]="crumb.route">
      <bit-icon-tile
        slot="start"
        [icon]="crumb.tile.icon"
        [variant]="crumb.tile.variant ?? 'primary'"
        [emphasis]="crumb.tile.emphasis ?? 'subtle'"
        aria-hidden="true"
      />
      {{ crumb.name }}
    </bit-breadcrumb>
  }

  <!--
    `[route]="[]"` plus `merge` resolves to the current URL, query params and all, which is what
    keeps this crumb active once the table writes its filter state there.
  -->
  <bit-breadcrumb icon="bwi-shared-folder" [route]="[]" queryParamsHandling="merge">
    {{ "sharedFolders" | i18n }}
  </bit-breadcrumb>
</bit-breadcrumbs>
